import React from 'react'
import Header from './../components/Header'
import Contents from './Contents'


function Sharedata() {
    return ( <
        div > < Header / > < Contents / > < /div>
    )
}

export default Sharedata